module.exports = __webpack_public_path__ + "static/media/premium.a694c826.svg";